/**
 * Horizontal and vertical separator components.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */

export const HorizontalDivider = ({ width }: { width?: string }) => {
  return (
    <div
      className="h-px bg-[#D4D4D4] horizontal-divider"
      style={width ? { width } : undefined}
    />
  )
}

export const VerticalDivider = ({ height }: { height: string }) => {
  return (
    <div className="w-px bg-[#D4D4D4] vertical-divider" style={{ height }} />
  )
}
